import {
	createMongoAbility,
	type MongoAbility,
	type RawRuleOf,
	type ForcedSubject,
} from '@casl/ability'
import { createContextualCan, useAbility as useBaseAbility } from '@casl/react'
import { createContext } from 'react'

export type { MongoAbility, RawRuleOf, ForcedSubject }

export const actions = [
	'manage',
	'approve',
	'create',
	'read',
	'view',
	'update',
	'modify',
	'delete',
] as const
export const subjects = [
	'quotation',
	'all_quotation',
	'policy',
	'all_policy',
	'endorsement',
	'report',
	'finance_report',
	'sales_report',
	'underwriting_report',
	'claim_report',
	'intermediary_report',
	'risk_report',
	'user',
	'customer',
	'all_customer',
	'organization',
	'organization_package',
	'product',
	'package',
	'all_package',
	'benefit',
	'risk',
	'invoice',
	'all_invoice',
	'configuration',
	'endorsement',
	'calculation_method',
	'calculation_discretion',
	'calculation_full_cancellation',
	'claim',
	'all',
	'rates',
] as const

export type Abilities = [
	(typeof actions)[number],
	(
		| (typeof subjects)[number]
		| ForcedSubject<Exclude<(typeof subjects)[number], 'all'>>
	),
]

export type AppAbility = MongoAbility<Abilities>

export const createAbility = (rules: RawRuleOf<AppAbility>[]) =>
	createMongoAbility<AppAbility>(rules)

// @ts-ignore
export const AbilityContext = createContext<AppAbility>()
export const AbilityProvider = AbilityContext.Provider
export const Can = createContextualCan<AppAbility>(AbilityContext.Consumer)
export const useAbility = () => useBaseAbility(AbilityContext)
